var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            fill-rule: evenodd;\n            }\n\n            .cls-1, .cls-2 {\n            fill: #1d1412;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25, 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.32,125.42c-15.53-.01-60,0-80.6,0-5.92,0-10.71-4.79-10.71-10.71v-59.35c0-5.92,4.8-10.71,10.71-10.71h91.33v17.01H19.68c-1.48,0-2.68,1.2-2.68,2.68v41.41c0,1.48,1.2,2.68,2.68,2.68h62.67c1.48,0,2.68-1.2,2.68-2.68v-9.52c0-1.48-1.2-2.68-2.68-2.68H29.76v-17.01h61.57c5.92,0,10.71,4.8,10.71,10.71v27.47c0,5.92-4.8,10.72-10.72,10.71ZM0,29.76V12.76h82.35c1.48,0,2.68-1.2,2.68-2.68V0h17.01v19.05c0,5.92-4.8,10.71-10.71,10.71H0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRound);
export default __webpack_public_path__ + "static/media/user-round.9c955de100ddec0e0ff47cd43d015aa1.svg";
export { ForwardRef as ReactComponent };